import React, { FC, useMemo } from 'react'

import clsx from 'clsx'

import { ApprovalRequestTableBody } from 'src/components/organisms/approvalRequests/ApprovalRequestTableBody'
import { ApprovalRequestTableHead } from 'src/components/organisms/approvalRequests/ApprovalRequestTableHead'

import { MyReviewingConfirmationEntity } from 'src/types'

type Props = {
  myReviewingConfirmations: MyReviewingConfirmationEntity[]
  className?: string
}

export const ApprovalRequestTable: FC<Props> = ({ myReviewingConfirmations, className }) => {
  const sortedConfirmations = useMemo(() => {
    return [...myReviewingConfirmations].sort((a, b) => {
      // 申請日時の降順でソート
      return a.createdAt.getTime() > b.createdAt.getTime() ? -1 : 1
    })
  }, [myReviewingConfirmations])

  return (
    <table className={className}>
      <ApprovalRequestTableHead
        className={clsx(
          'tw-sticky tw-top-0',
          // NOTE: スクロール時にスクロールバーの表示有無によってtheadの固定位置が微妙にズレる。それに伴い下にくる tbody 要素が見えてしまうことがあるため 1px 上にずらして防止する
          // 参考: https://github.com/STYLE-PORT/roov-works-client/issues/1921
          'tw-translate-y-[-1px]'
        )}
      />
      <ApprovalRequestTableBody myReviewingConfirmations={sortedConfirmations} />
    </table>
  )
}
